import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getInternationalOrdersCount = {
  name: "getInternationalOrdersCount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    days: z.union([z.literal(7), z.literal(30), z.literal(90)]),
  }),
  output: z.object({
    count: z.number(),
    precision: z.string(),
    homeCountryCode: z.string().nullable(),
    fetchedAt: z.date(),
    cached: z.boolean(),
  }),
};
